/* eslint-disable @reatom/unit-naming-rule */
import BigNumber from 'bignumber.js'

import { reatomLimitOrderBase } from './reatom-limit-order-base'

import type { PairModel } from '@root/entities/pair'
import type { TradeApi } from '@root/shared/api'

export const reatomLimitOrderBuy = ({
  dto,
  pair,
}: {
  dto: TradeApi.LimitOrderBuyDto
  pair: PairModel
}) => {
  const limitOrder = reatomLimitOrderBase({
    dto,
    pair,
  })

  const purchaseAmountBase = BigNumber(dto.amount)

  //#region State

  //#endregion

  //#region Computed

  const orderSizeCurrency = purchaseAmountBase.dividedBy(
    limitOrder.costAtCreationNative,
  )

  //#endregion

  return {
    ...limitOrder,
    type: 'buy' as const,
    orderSizeCurrency,
    purchaseAmountBase,
  }
}
export type LimitOrderBuyModel = ReturnType<typeof reatomLimitOrderBuy>
